import o from "./index.es223.js";
import r from "./index.es224.js";
import t from "./index.es225.js";
const e = {
  isBrowser: !0,
  classes: {
    URLSearchParams: o,
    FormData: r,
    Blob: t
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
export {
  e as default
};
//# sourceMappingURL=index.es172.js.map
